/*
 * @Author: mina.min
 * @Date: 2025-06-11 18:51:43
 * @LastEditors: mina.min
 * @LastEditTime: 2025-07-30 11:55:03
 * @FilePath: /OTAManagementSystem/src/pages/Login/index.tsx
 * @Description:
 */
import { useAuthStore } from '@/stores/authStore'
import { LockOutlined, UserOutlined } from '@ant-design/icons'
import { Button, Card, Form, Input, message } from 'antd'
import { observer } from 'mobx-react-lite'
import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import './index.scss'

interface LoginForm {
  username: string
  password: string
}

const Login: React.FC = observer(() => {
  const authStore = useAuthStore()
  const [form] = Form.useForm()
  const navigate = useNavigate()

  useEffect(() => {
    if (authStore.isAuthenticated) {
      navigate('/firmware/list')
    }
  }, [authStore.isAuthenticated, navigate])

  const handleSubmit = async (values: LoginForm) => {
    try {
      await authStore.login(values.username, values.password)
      message.success('登录成功')
      navigate('/firmware/list')
    } catch (error: any) {
      message.error(error.message || '登录失败，请检查您的凭据')
    }
  }

  return (
    <div className='login-container'>
      <div className='login-background'>
        <div className='login-overlay' />
      </div>
      <Card className='login-card' title='OTA管理系统'>
        <Form form={form} name='login' onFinish={handleSubmit} autoComplete='off' size='large'>
          <Form.Item name='username' rules={[{ required: true, message: '请输入用户名!' }]}>
            <Input prefix={<UserOutlined />} placeholder='用户名' />
          </Form.Item>

          <Form.Item name='password' rules={[{ required: true, message: '请输入密码!' }]}>
            <Input.Password prefix={<LockOutlined />} placeholder='密码' />
          </Form.Item>

          <Form.Item>
            <Button type='primary' htmlType='submit' loading={authStore.isLoading} block>
              登录
            </Button>
          </Form.Item>
        </Form>

        <div className='login-tips'>
          {/* <p>测试账号：test2 / test@2024#Safe</p> */}
          {/* <p>管理员：admin / Admin@2024!Secure</p>
          <p>开发者：developer / Dev@2024#Safe</p> */}
        </div>
      </Card>
    </div>
  )
})

export default Login
